import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {ForgotPassword} from 'app/modules/auth/components/ForgotPassword'
import {ResetPassword} from 'app/modules/auth/components/ResetPassword'
import {OnlineApplication} from 'app/modules/online-application/OnlineApplication'
import {AccountVerification} from 'app/modules/auth/components/AccountVerifcation'

const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='forgot-password' element={<ForgotPassword />} />
          <Route path='account-activation' element={<AccountVerification />} />
          <Route path='online-application' element={<OnlineApplication />} />
          <Route path='reset-password/:token' element={<ResetPassword />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
